import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { getCurrentPlan, getUserAllInformation } from "../../Redux/actions/commonActtion";
import "./success.css";
import { CelebrationFinal, New_ScrollX2025 } from "../../assets/icons";
import { getRequest } from "../../services/axios";

const SubscriptionSuccess = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId =
    searchParams.get("session_id") || searchParams.get("session-id");
  const [countdown, setCountdown] = useState(5);
  const [isLoading, setIsLoading] = useState(true);
  const purchaseEventSentRef = useRef(false);
  const { userData, currentPlan } = useSelector((state) => state?.commonReducer,);
  console.log('NewUser Data => ',userData);
  console.log('NewUser currentPlan => ',currentPlan);

  useEffect(() => {
    console.log('NewUser Data => ',userData);
    dispatch(getCurrentPlan());
  }, []);

  const planDetails = currentPlan?.plan?.plan_detail || {};
  const planType =
    searchParams.get("plan_type") || planDetails?.type || "FAST";
  const planAmount =
    searchParams.get("amount") || planDetails?.price || "99";
  const planCurrency =
    searchParams.get("currency") || planDetails?.currency || "usd";
  const planValidity =
    searchParams.get("validity") || planDetails?.validity || "7";
  const planInterval =
    searchParams.get("interval") || planDetails?.interval || "week";
  const planIntervalCount =
    searchParams.get("interval_count") || planDetails?.interval_count || "1";

  const currencySymbol =
    planCurrency?.toLowerCase() === "usd" || planCurrency === "$"
      ? "$"
      : `${planCurrency?.toUpperCase()} `;

  const renewalPeriod =
    Number(planIntervalCount) > 1
      ? `${planIntervalCount} ${planInterval}s`
      : planInterval;

  const handleGoToDashboard = useCallback(() => {
    if (userData?.[0]?.isCardAdded) {
      navigate("/dashboard");
    } else {
      navigate("/plans");
    }
  }, [navigate, userData]);

  // Fetch user information on mount
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        await dispatch(getUserAllInformation());
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching user data:", error);
        setIsLoading(false);
      }
    };

    fetchUserData();
  }, [dispatch]);

  useEffect(() => {
    if (!sessionId || purchaseEventSentRef.current) return;

    const sendPurchaseEvent = async () => {
      try {
        const response = await getRequest(`/user/payment/session/${sessionId}`);
        const sessionData = response?.data?.data;

        if (!response?.data?.success || !sessionData) return;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "purchase",
          transaction_id: sessionId,
          value: sessionData.amount,
          currency: sessionData.currency,
        });
        purchaseEventSentRef.current = true;
      } catch (error) {
        console.error("Error sending purchase event:", error);
      }
    };

    sendPurchaseEvent();
  }, [sessionId]);

  // Countdown timer and auto-redirect
  // useEffect(() => {
  //   // Don't start countdown until data is loaded
  //   if (isLoading || !userData) return;

  //   if (countdown > 0) {
  //     const timer = setTimeout(() => {
  //       setCountdown(countdown - 1);
  //     }, 1000);
  //     return () => clearTimeout(timer);
  //   } else {
  //     // Auto-redirect when countdown reaches 0
  //     handleGoToDashboard();
  //   }
  // }, [countdown, handleGoToDashboard, isLoading, userData]);

  // Show loading state while fetching user data
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 flex items-center justify-center p-4">
        <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
          <div className="mb-6 flex justify-center">
            <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
            </div>
          </div>
          <h1 className="text-2xl font-bold text-gray-800 mb-3 SuccessHeading">
            Loading your subscription details...
          </h1>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="spsContainer">

        <header class="topbar">
          <nav className="w-full flex justify-between">
            <a href="https://scrollx.io/" className="nav-logo">
              <span className="nav-logo-icon">
                <img className="logo-img999 " src={New_ScrollX2025} alt="icon" />
              </span>              
              <span>ScrollX</span>
            </a>

            {/* <div className="top-actions123">
              <span className=" hidden sm:block"></span>
              <Link to="/register" className="linkBtn">
                <span className="text-white  sm:block xl:text-[15px] manrope-300 ">Continue To Dashboard</span>
              </Link>
            </div> */}
          </nav>
        </header>

        <main className="page-main">
        
          <div id="loadingView" className="status-view" aria-live="polite" hidden>
            <div className="spinner" aria-label="Loading order details"></div>
          </div>

          <div id="errorView" className="error-box" role="alert" hidden></div>

          <section  id="successView"  className="success-view"  aria-labelledby="pageTitle">
    
            <div className="check-wrap" aria-hidden="true">
              <svg className="check-icon" viewBox="0 0 24 24" fill="none">
                <path
                  d="M20 6 9 17l-5-5"
                  stroke="currentColor"
                  strokeWidth="2.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            <h1 className="SuccessHeading" id="pageTitle">Welcome to ScrollX</h1>

            <p className="intro">Your 3-day 
              <span id="introPlanName"> {planType} </span> trial is now active.
              <span className="intro-secondary">Create professional end credits with unlimited renders, 4K exports, and complete creative control.</span>
            </p>

            <div className="plan-card">
              <div id="cardPlanName" className="plan-title">{planType}</div>

              <div>
                <div className="detail-row">
                  <div className="detail-label">Trial ends</div>
                  <div id="trialEnd" className="detail-value">{planValidity}</div>
                </div>

                <div className="detail-row">
                  <div className="detail-label">Due today</div>
                  <div className="detail-value">$0</div>
                </div>

                <div className="detail-row">
                  <div className="detail-label">First charge</div>
                  <div id="firstCharge" className="detail-value"> {currencySymbol} {Number(planAmount).toFixed(2)} on {renewalPeriod}</div>
                </div>
              </div>

              <div className="cancel-note">
                Cancel anytime before <span id="cancelDate">...</span> to avoid being charged.
              </div>

            </div>           

            <Link to="/dashboard" className="popup-btn px-3 py-2 rounded-2xl text-lg md:mt-2 lg:mt-4 text-white hover:scale-95 hover:ease-in duration-200 manrope-600 primary-button">
              Create your first credits  
              {/* ({countdown}) */}
              <svg
                className="chevron"
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="m9 18 6-6-6-6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Link>

          </section>

        </main>

      </div>

    {/* ========================================================== */}

    {/* <div className="customContainer w-100 h-100">
      <div className="popupContainer  lg:p-10 md:p-7 rounded-lg text-white">
        <div className="headerContent flex items-center gap-2 w-auto mr-10  mb-[0.8rem]">
          <img
            src={CelebrationFinal}
            className="h-16 w-16 flex"
            alt="celebration"
          />
          <h2 className="manrope-800 header lg:text-3xl md:text-2xl">
            You’re on the {planType} Plan Trial!
          </h2>
        </div>
        <div className="para lg:text-lg md:text-sm p-3 lg:leading-7 md:leading-5 manrope-400">
          <p className="text-center">
            Enjoy {planValidity} days of full access with unlimited renders, 4K
            exports, faster rendering, and complete creative control.
          </p>
          <p className="text-center">
            After the {planValidity}-day trial, the subscription renews
            automatically at {currencySymbol}
            {Number(planAmount).toFixed(2)} per {renewalPeriod} unless canceled
            before the trial ends.
          </p>
          {sessionId && (
            <p className="text-center text-xs opacity-70">
              Session ID: {sessionId}
            </p>
          )}
        </div>
        <Link
          to="/dashboard"
          className="popup-btn px-3 py-2 rounded-2xl text-lg md:mt-2 lg:mt-4 text-white hover:scale-95 hover:ease-in duration-200 manrope-600"
        >
          Continue To Dashboard ({countdown})
        </Link>
      </div>
    </div> */}

    </>
  );
};

export default SubscriptionSuccess;
